import React from "react";
import "./DayoffTable.css";
import { getUsedOvertimesForDayOff } from "../../../../api/api";

const DayoffTable = ({ dayoffData }) => {
  const PAGE_SIZE = 10;
  const [currentPage, setCurrentPage] = React.useState(1);
  const [selectedDayoff, setSelectedDayoff] = React.useState(null);
  const [isDetailsLoading, setIsDetailsLoading] = React.useState(false);
  const [detailsError, setDetailsError] = React.useState("");
  const [detailsData, setDetailsData] = React.useState(null);
  const [requestedDayoffId, setRequestedDayoffId] = React.useState(null);

  const getStatusClassName = (status) => {
    if (status.includes("Согласован")) return "status-approved";
    if (status.includes("Не согласован")) return "status-rejected";
    if (status.includes("На рассмотрении")) return "status-pending";
    return "";
  };

  const getRowClassName = (reviewers) => {
    if (!Array.isArray(reviewers)) return "";

    // Если есть хотя бы один отказ, строка красная
    if (
      reviewers.some((reviewer) => reviewer.status.includes("Не согласован"))
    ) {
      return "overtime-row--rejected";
    }

    // Если все согласовали, строка зеленая
    if (reviewers.every((reviewer) => reviewer.status.includes("Согласован"))) {
      return "overtime-row--approved";
    }

    return "";
  };

  // Сортируем данные по дате использования (от новых к старым)
  const sortedData = [...dayoffData].sort((a, b) => {
    const [dayA, monthA, yearA] = a.usageDate.split(".");
    const [dayB, monthB, yearB] = b.usageDate.split(".");
    const dateA = new Date(yearA, monthA - 1, dayA);
    const dateB = new Date(yearB, monthB - 1, dayB);
    return dateB - dateA;
  });

  const totalPages = Math.max(1, Math.ceil(sortedData.length / PAGE_SIZE));
  const startIndex = (currentPage - 1) * PAGE_SIZE;
  const paginatedData = sortedData.slice(startIndex, startIndex + PAGE_SIZE);

  React.useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const renderReviewers = (reviewers) => {
    if (!Array.isArray(reviewers)) return null;

    console.log(`Количество ревьюеров: ${reviewers.length}`);
    console.log("Ревьюеры:", reviewers);

    return reviewers.map((reviewer, index) => (
      <div key={index} className={getStatusClassName(reviewer.status)}>
        {reviewer.name}: {reviewer.status}
      </div>
    ));
  };

  const getOvertimesListFromResponse = (response) => {
    if (Array.isArray(response?.used_overtimes)) return response.used_overtimes;
    if (Array.isArray(response?.overtimes)) return response.overtimes;
    if (Array.isArray(response?.items)) return response.items;
    return [];
  };

  const normalizeOvertimeItem = (item) => {
    // Новый формат API: { day_off_overtime: {...}, overtime: {...} }
    if (item?.overtime) {
      return {
        ...item.overtime,
        allocated_time_spent: item?.day_off_overtime?.time_spent,
      };
    }
    // Fallback: старый/плоский формат
    return item || {};
  };

  const getReviewersFromOvertime = (overtime) => {
    if (!overtime || !overtime.status) return [];
    return Object.entries(overtime.status).map(([name, status]) => ({
      name,
      status:
        typeof status === "object"
          ? status?.is_approved
            ? "Согласован"
            : status?.is_approved === false
            ? "Не согласован"
            : "На рассмотрении"
          : status,
    }));
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString("ru-RU");
  };

  const formatHours = (seconds) => {
    if (seconds === null || seconds === undefined) return "-";
    const numeric = Number(seconds);
    if (Number.isNaN(numeric)) return String(seconds);
    return `${(numeric / 3600).toFixed(1).replace(".0", "")} ч`;
  };

  const openDetails = async (row) => {
    setSelectedDayoff(row);
    setRequestedDayoffId(row.id);
    setDetailsData(null);
    setDetailsError("");
    setIsDetailsLoading(true);
    try {
      const response = await getUsedOvertimesForDayOff(row.id);
      setDetailsData(response);
    } catch (error) {
      setDetailsError(error.message || "Не удалось загрузить детали отгула");
    } finally {
      setIsDetailsLoading(false);
    }
  };

  const closeDetails = () => {
    setSelectedDayoff(null);
    setRequestedDayoffId(null);
    setDetailsData(null);
    setDetailsError("");
    setIsDetailsLoading(false);
  };

  const dayOffFromResponse = detailsData?.day_off;
  const modalDayOffId = dayOffFromResponse?.id ?? selectedDayoff?.id;
  const modalDateOfUse = formatDate(
    dayOffFromResponse?.date_of_use || selectedDayoff?.usageDate
  );
  const modalHours = formatHours(dayOffFromResponse?.time ?? null).replace(" ч", "");

  return (
    <div className="dayoff-table-container">
      <h2 className="dayoff-table-title">Мои заявки на отгулы</h2>
      <table className="dayoff-table">
        <thead>
          <tr>
            {/* <th>Дата</th> */}
            <th>Часы</th>
            <th>Статус отгула</th>
            <th>Дата использования</th>
            <th>Детали</th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map((row, index) => (
            <tr
              key={startIndex + index}
              className={getRowClassName(row.reviewers)}
            >
              {/* <td>{row.date}</td> */}
              <td>{row.hours}</td>
              <td>{renderReviewers(row.reviewers)}</td>
              <td>{row.usageDate}</td>
              <td>
                <button
                  type="button"
                  className="dayoff-table__details-btn"
                  onClick={() => openDetails(row)}
                >
                  Детали
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {totalPages > 1 && (
        <div className="dayoff-table-pagination">
          <button
            type="button"
            className="dayoff-table-pagination__button"
            onClick={() => setCurrentPage((page) => Math.max(1, page - 1))}
            disabled={currentPage === 1}
          >
            Назад
          </button>
          <div className="dayoff-table-pagination__info">
            Страница {currentPage} из {totalPages}
          </div>
          <button
            type="button"
            className="dayoff-table-pagination__button"
            onClick={() =>
              setCurrentPage((page) => Math.min(totalPages, page + 1))
            }
            disabled={currentPage === totalPages}
          >
            Вперёд
          </button>
        </div>
      )}

      {selectedDayoff && (
        <div className="dayoff-details-modal-overlay" onClick={closeDetails}>
          <div
            className="dayoff-details-modal"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="dayoff-details-modal__header">
              <h3>Детали отгула</h3>
              <button
                type="button"
                className="dayoff-details-modal__close"
                onClick={closeDetails}
              >
                Закрыть
              </button>
            </div>

            <div className="dayoff-details-modal__meta">
              <div>
                <strong>ID отгула:</strong> {modalDayOffId || "-"}
              </div>
              <div>
                <strong>Дата использования:</strong> {modalDateOfUse}
              </div>
              <div>
                <strong>Часы отгула:</strong>{" "}
                {dayOffFromResponse?.time != null ? modalHours : selectedDayoff.hours}
              </div>
              {!isDetailsLoading &&
                requestedDayoffId &&
                dayOffFromResponse?.id &&
                Number(requestedDayoffId) !== Number(dayOffFromResponse.id) && (
                  <div className="dayoff-details-modal__state dayoff-details-modal__state--error">
                    В ответе пришел другой day_off_id: запрошен {requestedDayoffId},
                    получен {dayOffFromResponse.id}
                  </div>
                )}
            </div>

            {isDetailsLoading && (
              <div className="dayoff-details-modal__state">Загрузка...</div>
            )}

            {!isDetailsLoading && detailsError && (
              <div className="dayoff-details-modal__state dayoff-details-modal__state--error">
                {detailsError}
              </div>
            )}

            {!isDetailsLoading && !detailsError && (
              <>
                {getOvertimesListFromResponse(detailsData).length === 0 ? (
                  <div className="dayoff-details-modal__state">
                    Для этого отгула не найдено распределенных переработок.
                  </div>
                ) : (
                  <table className="dayoff-details-modal__table">
                    <thead>
                      <tr>
                        <th>Дата</th>
                        <th>Проект</th>
                        <th>Часы</th>
                        <th>Статусы согласования</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getOvertimesListFromResponse(detailsData).map((item, idx) => {
                        const overtime = normalizeOvertimeItem(item);
                        return (
                        <tr key={overtime.id || idx}>
                          <td>{formatDate(overtime.fact_date_start)}</td>
                          <td>{overtime.project_name || "-"}</td>
                          <td>
                            {formatHours(
                              overtime.allocated_time_spent ??
                                overtime.used_time_spent ??
                                overtime.time_spent
                            )}
                          </td>
                          <td>
                            {getReviewersFromOvertime(overtime).map((reviewer, idx) => (
                              <div key={`${overtime.id}-${idx}`}>
                                {reviewer.name}: {reviewer.status}
                              </div>
                            ))}
                          </td>
                        </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DayoffTable;
